import { Typography } from '@mui/material';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import trScreenVideo from '../../../../../assets/video/tr-screen-video.mp4';
import trVideoMobile from '../../../../../assets/video/tr-video-mobile.mp4';
import Prompt from '../../../../Prompt/Prompt';

import {
  TXTCLI_Once_you_depositX_youXll_be_go_ELL,
  TXTCLI_Thanks,
  TXTWCL_Continue_to_deposit
} from './RMFUSPAFinishPrompt.messages.json';

const RMFUSPAFinishScreen: React.FC = () => {
  const form = useForm();
  const isMobile = useSelector(select.device.isMobile);
  const video = isMobile ? trVideoMobile : trScreenVideo;

  return (
    <Prompt
      noCloseButton
      variant="info"
      video={video}
      title={{ translation: TXTCLI_Thanks }}
      primaryButton={{ translation: TXTWCL_Continue_to_deposit }}
      onPrimaryButtonClick={() => {
        form.submit();
      }}
    >
      <Typography>
        <Translation {...TXTCLI_Once_you_depositX_youXll_be_go_ELL} />
      </Typography>
    </Prompt>
  );
};

export default RMFUSPAFinishScreen;
